import React from 'react';

const SecondHome = ({ theme = "green", primaryColor }) => {
    // Dynamic theme colors matching the main dashboard theme
    const activePrimary = primaryColor || (theme === "green" ? "#10b981" : "#3b82f6");
    const primaryGlow = theme === "green" ? "rgba(16, 185, 129, 0.15)" : "rgba(59, 130, 246, 0.15)";

    const featureList = [
        "Real-time market data and advanced charting",
        "Risk management tools and automated execution",
        "Dedicated account support and tailored strategies",
        "24/7 priority customer support round the clock",
        "Instant settlement and guaranteed transaction security",
        "Strategic order placement and portfolio planning"
    ];

    return (
        <section style={styles.sectionWrapper}>
            <div style={styles.container}>
                <div style={styles.gridContainer}>
                    {/* Left Pane: Image Showcase with Ambient Glow */}
                    <div style={styles.leftPane}>
                        <div style={{ ...styles.glowBackdrop, backgroundColor: activePrimary }} />
                        <img 
                            style={styles.heroImg} 
                            src={require("../assets/img/btc3.png")} 
                            alt="Crypto Trading Showcase" 
                        />
                    </div>

                    {/* Right Pane: Content & Feature Checklist */}
                    <div style={styles.rightPane}>
                        <div style={{ ...styles.sectionBadge, backgroundColor: `${activePrimary}15`, borderColor: `${activePrimary}35` }}>
                            <span style={{ color: activePrimary, fontWeight: 600 }}>Why Choose Our Platform</span>
                        </div>

                        <h2 style={styles.heading}>
                            Trade Crypto with <span style={{ color: activePrimary }}>Confidence</span>
                        </h2>

                        <p style={styles.leadText}>
                            Access lightning-fast execution, military-grade security, and expert guidance. 
                            We help traders at every level navigate global financial markets with ultra-low latency 
                            and total transparency.
                        </p>

                        <div style={styles.listGrid}>
                            {featureList.map((item, index) => (
                                <div key={index} style={styles.listItem}>
                                    <div style={{ ...styles.checkIconBox, backgroundColor: `${activePrimary}20`, color: activePrimary }}>
                                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                                            <polyline points="20 6 9 17 4 12"></polyline>
                                        </svg>
                                    </div>
                                    <span style={styles.listText}>{item}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

const styles = {
    sectionWrapper: {
        width: "100%",
        padding: "60px 0",
        backgroundColor: "transparent",
    },
    container: {
        maxWidth: 1240,
        margin: "0 auto",
        padding: "0 24px",
        boxSizing: "border-box",
    },
    gridContainer: {
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
        gap: 48,
        alignItems: "center",
        backgroundColor: "rgba(15, 23, 42, 0.6)",
        backdropFilter: "blur(16px)",
        borderRadius: 24,
        border: "1px solid rgba(255, 255, 255, 0.08)",
        padding: "48px 36px",
        boxShadow: "0 20px 40px -15px rgba(0, 0, 0, 0.4)",
    },
    leftPane: {
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: 320,
    },
    glowBackdrop: {
        position: "absolute",
        width: "60%",
        height: "60%",
        borderRadius: "50%",
        filter: "blur(70px)",
        opacity: 0.35,
        zIndex: 0,
    },
    heroImg: {
        width: "85%",
        maxWidth: 420,
        height: "auto",
        objectFit: "contain",
        position: "relative",
        zIndex: 1,
        filter: "drop-shadow(0 15px 25px rgba(0,0,0,0.5))",
        transition: "transform 0.3s ease",
    },
    rightPane: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
    },
    sectionBadge: {
        display: "inline-flex",
        alignItems: "center",
        padding: "6px 14px",
        borderRadius: 999,
        border: "1px solid",
        fontSize: 13,
        marginBottom: 16,
    },
    heading: {
        margin: "0 0 16px 0",
        fontSize: "clamp(1.8rem, 3vw, 2.4rem)",
        fontWeight: 800,
        color: "#f8fafc",
        lineHeight: 1.2,
        letterSpacing: "-0.01em",
    },
    leadText: {
        margin: "0 0 28px 0",
        color: "#94a3b8",
        fontSize: 15,
        lineHeight: 1.65,
    },
    listGrid: {
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
        gap: 14,
        width: "100%",
    },
    listItem: {
        display: "flex",
        alignItems: "center",
        gap: 12,
    },
    checkIconBox: {
        width: 22,
        height: 22,
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
    },
    listText: {
        fontSize: 14,
        color: "#cbd5e1",
        fontWeight: 500,
    },
};

export default SecondHome;